import { Enviroment } from '../constants/enviroment-v2.constant';
export const IsProduction = () => {
	if (Enviroment.DOPPLER_ENVIRONMENT === 'master') console.log = function () {};
};
